import { Box, Typography, useMediaQuery, useTheme} from "@mui/material";

const columnBox = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  padding: 0,
  position: "relative",
  height: "min-content",
};

const textStyle = {
  fontSize: { xs: "16px", md: "22px" },
  cursor: "pointer",
  lineHeight: '180%',
};

const socialLinks = [
  { label: "Instagram", url: "https://www.instagram.com/_broadcaststudio/" },
  { label: "Facebook", url: "https://www.facebook.com/BroadcastOxfordMS" },
  { label: "LinkedIn", url: "https://www.linkedin.com/company/broadcast-studio-llc/" },
];


export default function Footer() {
    const handleLinkClick = (url: string) => {
        window.open(url, "_blank", "noopener,noreferrer");
    };

    const handleEmailClick = () => handleLinkClick("mailto:info@broadcaststudio.com");
    const handleWebsiteClick = () => handleLinkClick("https://www.broadcaststudio.com/");

    const theme = useTheme();
    const isMdOrLess = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <>
            <Box
                component="footer"
                sx={{
                    position: "sticky",
                    bottom: 0,
                    width: "100%",
                    height: 'fit-content',
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    bgcolor: "#caf76f",
                    zIndex: 1,
                }}
            >
                <Box
                    sx={{
                        ...columnBox,
                        alignItems: "flex-start",
                        gap: { xs: 4, md: 6 },
                        py: { xs: 6, md: 10 },
                        width: "100%",
                        maxWidth: "1208px",
                        mx: "auto",
                        pl: 2,
                        pr: 3,
                    }}
                >
                    <Typography sx={{ fontSize: "16px", lineHeight: '180%'}}>CONTACT</Typography>

                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" },
                            width: "100%",
                            gap: { xs: 4, md: 6 },
                            alignItems: { xs: "flex-start", md: "flex-start" },
                            justifyContent: "center",
                        }}
                    >
                        <Box sx={{ ...columnBox, flex: 1, gap: 1 }}>
                            <Typography sx={{ fontSize: "22px", lineHeight: '180%' }}>
                                426 South Lamar Blvd
                                <br />
                                Oxford, MS 38655
                            </Typography>
                        </Box>

                        <Box sx={{ ...columnBox, flex: 1, gap: 1, lineHeight: '180%' }}>
                            <Typography className="underlined-text" sx={textStyle} onClick={handleEmailClick}>
                                info@broadcaststudio.com
                            </Typography>
                            <Typography className="underlined-text" sx={textStyle} onClick={handleWebsiteClick}>
                                broadcaststudio.com
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                flexWrap: "wrap",
                                alignItems: { xs: "flex-start", sm: "center" },
                                gap: "32px",
                                flex: 1,
                            }}
                        >
                            {socialLinks.map((link) => (
                                <Typography
                                    key={link.label}
                                    className="underlined-text"
                                    sx={textStyle}
                                    onClick={() => handleLinkClick(link.url)}
                                >
                                    {link.label}
                                </Typography>
                            ))}
                        </Box>
                    </Box>

                    <Typography sx={{ fontSize: "16px", textAlign: "left", fontWeight: '500' }}>
                        Broadcast 2025 #create #record
                    </Typography>
                </Box>

                {!isMdOrLess && (
                    <Box
                        sx={{
                            width: "100%",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            bgcolor: "#caf76f",
                            position: "relative",
                            zIndex: -1,
                            height: "240px",
                        }}
                    >
                        <Box
                            sx={{
                                position: "absolute",
                                top: "-140px",
                                left: 0,
                                display: "flex",
                                whiteSpace: "nowrap",
                                animation: "scroll-left 600s linear infinite",
                                lineHeight: "480px",
                                '@keyframes scroll-left': {
                                "0%": { transform: "translateX(0%)" },
                                "100%": { transform: "translateX(-50%)" },
                                },

                                gap: '20px',
                            }}
                        >
                            {[...Array(2)].map((_, j) => (
                                <Box key={j} sx={{ display: 'flex' }}>
                                    {Array(20).fill(" GET IN TOUCH ").map((text, i) => (
                                        <Typography
                                        key={`${j}-${i}`}
                                        component="span"
                                        sx={{
                                            fontSize: "480px",
                                            fontWeight: 800,
                                            display: "inline-block",
                                            color: "black",
                                            mr: i === 19 ? 0 : "80px",
                                        }}
                                        >
                                        {text}
                                        </Typography>
                                    ))}
                                </Box>
                            ))}
                        </Box>
                    </Box>
                )}
            </Box>
        </>
    );
}
